import { refProcessGroupCaption } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { ProcessGroupCaptionDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["PROCESS_GROUP_CAPTION_QUEUE_URL"]

export const getRefProcessGroupCaptionData = async (
  tx: DbTransaction,
  id: string,
): Promise<ProcessGroupCaptionDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refProcessGroupCaption.id,
      processGroupId: refProcessGroupCaption.processGroupId,
      textEn: refProcessGroupCaption.text_en,
      textTranslations: refProcessGroupCaption.text_translations,
      createdAt: refProcessGroupCaption.createdAt,
      createdBy: refProcessGroupCaption.createdBy,
      updatedAt: refProcessGroupCaption.updatedAt,
      updatedBy: refProcessGroupCaption.updatedBy,
    })
    .from(refProcessGroupCaption)
    .where(eq(refProcessGroupCaption.id, parseInt(id)))

  if (!row) {
    console.error(`RefProcessGroupCaption with id ${id} not found`)
    return
  }

  const refProcessGroupCaptionDoc: ProcessGroupCaptionDoc = {
    id: row.id.toString(),
    process_group_id: row.processGroupId,
    text_en: row.textEn,
    text_translations:
      (row.textTranslations as Array<{ lang: string; text: string }>) ?? null,
    created_at: row.createdAt.getTime(),
    created_by: row.createdBy ?? null,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy ?? null,
  }

  searchBuilderLog.debug({
    document: refProcessGroupCaptionDoc,
  })

  return refProcessGroupCaptionDoc
}

export const saveRefProcessGroupCaptionToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefProcessGroupCaptionData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
